/*
  Yadegari — Stack builder (Oct 2026). Markup and config: sections/yadegari-stack-builder.liquid.
  One instance per section on the page.
*/
(function () {
  function init(root) {
    if (root.dataset.yadStackReady) return;
    root.dataset.yadStackReady = '1';
    var cfg = JSON.parse(root.querySelector('[data-yad-stack-config]').textContent);

    var MAX = cfg.max;
    var MONEY_FORMAT = cfg.moneyFormat;
    var CART_ADD = cfg.cartAdd;
    var CART_URL = cfg.cartUrl;
    var DELIVERY = cfg.delivery;
    var STACK_PROPERTY = cfg.stackProperty;
    var LENGTH_REQUIRED = cfg.lengthRequired;
    var NO_COMMON_LENGTH = cfg.noCommonLength;
    var MAX_TEXT = cfg.maxText;
    var ADDING = cfg.adding;
    var ERROR_TEXT = cfg.errorText;

    var products = {};
    root.querySelectorAll('[data-yad-stack-choice]').forEach(function (li) {
      var data = JSON.parse(li.querySelector('[data-yad-stack-data]').textContent);
      data.el = li;
      data.color = data.colorOption ? data.variants[0].options[data.optionNames.indexOf(data.colorOption)] : null;
      var colorBtn = li.querySelector('[data-yad-stack-color][aria-pressed="true"]');
      if (colorBtn) data.color = colorBtn.getAttribute('data-yad-stack-color');
      products[data.id] = data;
    });

    var selected = []; // product ids in order
    var length = null; // chosen length value, e.g. "17 cm"
    var chipKey = ''; // which lengths the chips currently show

    var tray = root.querySelector('[data-yad-stack-tray]');
    var emptyText = root.querySelector('[data-yad-stack-empty]');
    var slots = Array.prototype.slice.call(root.querySelectorAll('[data-yad-stack-slot]'));
    var summary = root.querySelector('[data-yad-stack-summary]');
    var lengthBox = root.querySelector('[data-yad-stack-length]');
    var lengthChips = root.querySelector('[data-yad-stack-length-chips]');
    var totalEl = root.querySelector('[data-yad-stack-total]');
    var addBtn = root.querySelector('[data-yad-stack-add]');
    var addLabel = root.querySelector('[data-yad-stack-add-label]');
    var addLabelText = addLabel.textContent;
    var errorEl = root.querySelector('[data-yad-stack-error]');
    var countEl = root.querySelector('[data-yad-stack-count]');

    function formatMoney(cents) {
      var value = (cents / 100).toFixed(2);
      var parts = value.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var withDecimals = whole + '.' + parts[1];
      var noDecimals = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return MONEY_FORMAT
        .replace('{{amount}}', withDecimals)
        .replace('{{amount_no_decimals}}', noDecimals)
        .replace('{{amount_with_comma_separator}}', withDecimals.replace(/,/g, ' ').replace('.', ','))
        .replace('{{amount_no_decimals_with_comma_separator}}', noDecimals.replace(/,/g, ' '))
        .replace('{{amount_with_space_separator}}', withDecimals.replace(/,/g, ' '))
        .replace('{{amount_no_decimals_with_space_separator}}', noDecimals.replace(/,/g, ' '));
    }

    // variant.options follows the product's option order
    function optionIndex(p, name) {
      return p.optionNames.indexOf(name);
    }

    // The variant that matches the piece's chosen colour and the stack length.
    function variantFor(p) {
      var ci = p.colorOption ? optionIndex(p, p.colorOption) : -1;
      var li = p.lengthOption ? optionIndex(p, p.lengthOption) : -1;
      var match = p.variants.filter(function (v) {
        if (ci !== -1 && v.options[ci] !== p.color) return false;
        if (li !== -1 && length && v.options[li] !== length) return false;
        return true;
      });
      return match[0] || null;
    }

    function imageFor(p) {
      if (p.stackImage) return { src: p.stackImage, cutout: true };
      var ci = p.colorOption ? optionIndex(p, p.colorOption) : -1;
      if (ci !== -1) {
        var v = p.variants.filter(function (x) { return x.options[ci] === p.color && x.image; })[0];
        if (v) return { src: v.image, cutout: false };
      }
      return { src: p.image, cutout: false };
    }

    function needsLength() {
      return selected.some(function (id) { return products[id].lengthOption; });
    }

    function commonLengths() {
      var lists = selected.map(function (id) { return products[id].lengths; }).filter(function (l) { return l.length; });
      if (!lists.length) return [];
      return lists[0].filter(function (val) {
        return lists.every(function (l) { return l.indexOf(val) !== -1; });
      });
    }

    function render() {
      // Tray
      emptyText.hidden = selected.length > 0;
      slots.forEach(function (slot, i) {
        var id = selected[i];
        if (!id) { slot.hidden = true; return; }
        var p = products[id];
        var img = imageFor(p);
        var tag = slot.querySelector('img');
        if (tag.getAttribute('src') !== img.src) tag.src = img.src;
        tag.alt = p.title + (p.color ? ' — ' + p.color : '');
        slot.classList.toggle('yad-stack__slot--cutout', img.cutout);
        slot.querySelector('figcaption').textContent = p.title;
        slot.hidden = false;
      });
      tray.setAttribute('data-count', selected.length);

      // Lengths
      var lengths = commonLengths();
      if (needsLength() && lengths.length) {
        lengthBox.hidden = false;
        if (length && lengths.indexOf(length) === -1) length = null;
        if (chipKey !== lengths.join('|')) {
          chipKey = lengths.join('|');
          lengthChips.innerHTML = '';
          lengths.forEach(function (val) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'yad-stack__chip';
            b.textContent = val;
            b.setAttribute('data-yad-stack-chip', val);
            b.addEventListener('click', function () { length = val; render(); });
            lengthChips.appendChild(b);
          });
        }
        lengthChips.querySelectorAll('[data-yad-stack-chip]').forEach(function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-yad-stack-chip') === length ? 'true' : 'false');
        });
      } else {
        lengthBox.hidden = true;
        length = null;
        chipKey = '';
      }

      // Summary + total
      summary.innerHTML = '';
      var total = 0;
      var allAvailable = true;
      selected.forEach(function (id) {
        var p = products[id];
        var v = variantFor(p);
        var li = document.createElement('li');
        var price = v ? v.price : p.variants[0].price;
        if (!v || !v.available) allAvailable = false;
        total += price;
        li.innerHTML =
          '<span class="yad-stack__summary-title">' + escapeHtml(p.title) + (p.color ? ' <em>' + escapeHtml(p.color) + '</em>' : '') + '</span>' +
          '<span class="yad-stack__summary-price">' + formatMoney(price) + '</span>' +
          '<button type="button" class="yad-stack__summary-remove" aria-label="' + escapeHtml(cfg.removeLabel) + ' ' + escapeHtml(p.title) + '">×</button>';
        li.querySelector('button').addEventListener('click', function () {
          toggle(id);
          var back = p.el.querySelector('[data-yad-stack-toggle]');
          if (back) back.focus();
        });
        summary.appendChild(li);
      });
      totalEl.textContent = selected.length ? formatMoney(total) : '—';
      countEl.textContent = selected.length + '/' + MAX;

      // Chooser state
      Object.keys(products).forEach(function (id) {
        var p = products[id];
        var on = selected.indexOf(Number(id)) !== -1;
        p.el.classList.toggle('is-selected', on);
        p.el.classList.toggle('is-disabled', !on && selected.length >= MAX);
        var t = p.el.querySelector('[data-yad-stack-toggle]');
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
        t.disabled = !on && selected.length >= MAX;
        var n = p.el.querySelector('.yad-stack__choice-num');
        if (on) {
          if (!n) { n = document.createElement('span'); n.className = 'yad-stack__choice-num'; p.el.appendChild(n); }
          n.textContent = selected.indexOf(Number(id)) + 1;
        } else if (n) {
          n.remove();
        }
      });

      // Button
      var ready = selected.length >= 2 && (!needsLength() || length) && allAvailable;
      addBtn.disabled = !ready;
      if (needsLength() && !lengths.length) showError(NO_COMMON_LENGTH);
      else showError(selected.length >= 2 && needsLength() && !length ? LENGTH_REQUIRED : '');
    }

    function showError(msg) {
      errorEl.textContent = msg || '';
      errorEl.hidden = !msg;
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function toggle(id) {
      id = Number(id);
      var i = selected.indexOf(id);
      if (i !== -1) selected.splice(i, 1);
      else if (selected.length < MAX) selected.push(id);
      else { showError(MAX_TEXT); return; }
      render();
    }

    // Events
    Object.keys(products).forEach(function (id) {
      var p = products[id];
      p.el.querySelector('[data-yad-stack-toggle]').addEventListener('click', function () { toggle(id); });
      p.el.querySelectorAll('[data-yad-stack-color]').forEach(function (b) {
        b.addEventListener('click', function () {
          p.color = b.getAttribute('data-yad-stack-color');
          p.el.querySelectorAll('[data-yad-stack-color]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          var img = imageFor(p);
          var cardImg = p.el.querySelector('.yad-stack__choice-media img');
          if (cardImg && !img.cutout) { cardImg.src = img.src; cardImg.srcset = ''; }
          render();
        });
      });
    });

    addBtn.addEventListener('click', function () {
      var items = [];
      for (var i = 0; i < selected.length; i++) {
        var p = products[selected[i]];
        var v = variantFor(p);
        if (!v) { showError(ERROR_TEXT); return; }
        var props = {};
        props[DELIVERY.name] = DELIVERY.value;
        if (STACK_PROPERTY) props[STACK_PROPERTY] = selected.length + ' pieces';
        items.push({ id: v.id, quantity: 1, properties: props });
      }
      addBtn.disabled = true;
      addLabel.textContent = ADDING;
      showError('');
      fetch(CART_ADD, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (r.ok) return;
          return r.json().then(function (j) {
            throw new Error((j && (j.description || j.message)) || ERROR_TEXT);
          }, function () { throw new Error(ERROR_TEXT); });
        })
        .then(function () { window.location.href = CART_URL; })
        .catch(function (err) {
          addBtn.disabled = false;
          addLabel.textContent = addLabelText;
          showError(err.message || ERROR_TEXT);
        });
    });

    render();
  }

  document.querySelectorAll('.yad-stack[data-yad-stack]').forEach(init);
})();